'use client';

import Image, { type StaticImageData } from 'next/image';

import aathiraiCraftzLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/aathirai-craftz-logo-white.png';
import lunaLeafLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/luna-leaf-logo-white.png';
import hafeelaLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/hafeela-logo-white.png';
import meesakarLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/meesakar-logo-white.png';
import adyarHandicraftsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/adyar-handicrafts-logo-white.png';
import magizhHandicraftsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/magizh-handicrafts-logo-white.png';
import brassIdolsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/brass-idols-logo-white.png';
import thingalEssentialsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/thingal-essentials-logo-white.png';
import natrilNaturalsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/natril-naturals-logo-white.png';
import polivuLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/polivu-logo-white.webp';
import tamilTshirtsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/tamil-tshirts-logo-white.png';
import mypoloLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/mypolo-logo-white.png';
import krishnaSeedsLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/krishna-seeds-white.png';
import bogilifeLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/bogilife-logo-white.webp';
import fanboyStoreLogoWhite from '../images/Mainpage/client-logos/d2c-client-logos-white/fanboy-store-logo-white.png';

// Aathirai Craftz and Luna Leaf still only have color logos on file — everyone else below has
// a white-ink version now.
const D2C_CLIENTS: { src: StaticImageData; alt: string; href?: string }[] = [
  { src: aathiraiCraftzLogoWhite, alt: 'Aathirai Craftz Logo', href: 'https://www.aathiraicraftz.com/' },
  { src: hafeelaLogoWhite, alt: 'Hafeela Logo', href: 'https://hafeelatextilenextjs.pages.dev/' },
  { src: lunaLeafLogoWhite, alt: 'Luna Leaf Logo', href: 'https://lunaleafnext.pages.dev/' },
  { src: meesakarLogoWhite, alt: 'Meesakar Logo', href: 'https://www.meesakar.in/' },
  { src: adyarHandicraftsLogoWhite, alt: 'Adyar Handicrafts Logo', href: 'https://www.adyarhandicrafts.com/' },
  { src: magizhHandicraftsLogoWhite, alt: 'Magizh Handicrafts Logo', href: 'https://www.magizhhandicrafts.com/' },
  { src: brassIdolsLogoWhite, alt: 'Brass Idols Logo', href: 'https://www.brassidols.com/' },
  { src: thingalEssentialsLogoWhite, alt: 'Thingal Essentials Logo', href: 'https://thingalessentials.com/' },
  { src: natrilNaturalsLogoWhite, alt: 'Natril Naturals Logo', href: 'https://natrilnaturals.com/' },
  { src: polivuLogoWhite, alt: 'Polivu Logo', href: 'https://polivueco.com/' },
  { src: tamilTshirtsLogoWhite, alt: 'Tamil Tshirts Logo', href: 'https://www.tamiltshirts.in/' },
  { src: mypoloLogoWhite, alt: 'My Polo Club Logo', href: 'https://mypolo.in/' },
  { src: krishnaSeedsLogoWhite, alt: 'Krishna Seeds Logo', href: 'https://www.krishnaseeds.in/' },
  { src: bogilifeLogoWhite, alt: 'BogiLife Logo', href: 'https://bogilife.com/' },
  { src: fanboyStoreLogoWhite, alt: 'FanBoy Store Logo', href: 'https://www.fanboystore.in/' },
];

const OurD2CClientsSlider = () => {
  // Same marquee mechanism as BankingPartnersSLider.tsx (duplicated list + CSS marquee-track
  // animation), so this reads as the same visual family as "Banking Partners & Our Clients".
  const duplicated = [...D2C_CLIENTS, ...D2C_CLIENTS];

  return (
    <div className="bg-[#090C24] py-3">
      <p className="my-3 flex items-center justify-center gap-2 font-Schibsted_Grotesk text-[10px] font-bold uppercase tracking-[4px] text-[#FFADA6]">
      Our Vilva D2C Clients
      </p>
     
      <div className="overflow-hidden relative z-20">
        <div
          className="marquee-track w-max flex items-center"
          style={{ animation: 'marqueeToLeft 160s linear infinite' }}
        >
          {duplicated.map((client, index) =>
            client.href ? (
              <a
                key={index}
                href={client.href}
                target="_blank"
                rel="noopener noreferrer"
                title={client.alt}
                className="flex-shrink-0 mx-4 flex p-2 h-[70px] w-[120px] items-center justify-center transition-transform hover:-translate-y-0.5"
              >
                <Image src={client.src} className="h-full w-full object-contain" alt={client.alt} />
              </a>
            ) : (
              <div
                key={index}
                className="flex-shrink-0 mx-4 flex p-2 h-[70px] w-[120px] items-center justify-center"
              >
                <Image src={client.src} className="h-full w-full object-contain" alt={client.alt} />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default OurD2CClientsSlider;
